import axiosInstance from "../../../features/api/axiosInstance";
const base_url = process.env.REACT_APP_API_URL;

const API_URL = `${base_url}user/policy-documents`; // Replace "our-service" with your actual endpoint

// ✅ Get all items
const getPolicyDocuments = async (params) => {

  const response = await axiosInstance.get(API_URL,{
    params: {
      ...params,
    },
  });
  return response.data;
};


const getPolicyDocumentByUuid = async (uuid) => {
  const response = await axiosInstance.get(`${API_URL}/${uuid}`);
  return response.data;
};

const policyDocument = {
  getPolicyDocuments,
  getPolicyDocumentByUuid
};

export default policyDocument;
